import { render } from "./Employee.vue?vue&type=template&id=40aa56e6&scoped=true"
import script from "./Employee.vue?vue&type=script&lang=ts"
export * from "./Employee.vue?vue&type=script&lang=ts"

import "./Employee.vue?vue&type=style&index=0&id=40aa56e6&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-40aa56e6"

export default script